import { request } from '../lib/http'

export function inactiveDriver (id, data) {
  return request({
    url: `frota/driver/inactive/${id}`,
    method: 'patch',
    data
  })
}

export function inactiveHelper (id, data) {
  return request({
    url: `frota/helper/inactive/${id}`,
    method: 'patch',
    data
  })
}
